// @ts-nocheck
import axios from "@/helpers/interceptors";
import { B2bPortalRight } from "@/enums/B2bPortalRight";
import { vuexHasPortalRight } from "@/helpers/vuexPortalPermissions";

const state = {
  cards: [],
  cardTypes: [],
  cardTypesArts: [],
  isLoadingCards: false,
  isLoadingCartTypesArts: false,
  defaultDeliveryAddress: null,
  shippingClasses: []
};

const mutations = {
  SET_CARDS(state, payload) {
    state.cards = payload;
  },
  SET_CARD_TYPES_ART(state, payload) {
    if (!state.cardTypesArts.find(item => item.id === payload.id)) {
      state.cardTypesArts.push(payload);
    }
  },
  SET_CARD_TYPES(state, payload) {
    state.cardTypes = payload;
  },
  SET_DEFAULT_DELIVERY_ADDRESS(state, payload) {
    state.defaultDeliveryAddress = payload;
  },
  SET_SHIPPING_CLASS(state, payload) {
    state.shippingClasses = payload;
  }
};

const actions = {

  /**
   * @name fetchCards
   * @description Get list of cards
   * @param state
   * @param commit
   * @param dispatch
   */
  async fetchCards({
                     state, commit, dispatch, rootState
                   }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) {
      commit("SET_CARDS", []);
      return;
    }
    try {
      state.isLoadingCards = true;
      const { status, data } = await axios.get("/api/cards/list");
      console.log(data, "cards");

      if (status === 200 && data.length) {
        state.isLoadingCartTypesArts = true;
        commit("SET_CARDS", data);
        let ids = Array.from(new Set(data.map((card) => card.cardType.id)));
        if (state.cardTypesArts.length) {
          const cardTypesArtsIds = state.cardTypesArts.map((typeArt) => typeArt.id);
          ids = ids.filter((num) => !cardTypesArtsIds.includes(num));
        }
        if (ids.length) {
          ids.forEach(async (id, i) => {
            const cardTypeArt = await dispatch("fetchCardTypeArtById", id);
            if (cardTypeArt) {
              cardTypeArt.id = id;
              commit("SET_CARD_TYPES_ART", cardTypeArt);
              if (i === ids.length - 1) {
                state.isLoadingCartTypesArts = false;
              }
            }
          });
        } else {
          state.isLoadingCartTypesArts = false;
        }
        console.log("isLoading");
      }
    } catch (e) {
      console.log(e);
    } finally {
      state.isLoadingCards = false;
    }
  },

  /**
   * @name fetchCardTypeArtById
   * @description Get image of card by id
   * @param _
   * @param id
   */

  async fetchCardTypeArtById({ rootState }, id) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) return;
    try {
      const { status, data } = await axios.get(`/api/cards/type-artwork/${id}`);
      if (status === 200) {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name fetchCardPanAndCVV
   * @description Get pan number and cvv code from card
   */

  async fetchCardPanAndCVV({ rootState }, publicToken) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) return;
    try {
      const { status, data } = await axios.get(`/api/cards/get-pan/${publicToken}`);
      if (status === 200) {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name changeCardName
   * @description change name of the card
   */

  async changeCardName({ dispatch, rootState }, data) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/change-name", data);
      if (status === 200) {
        dispatch("fetchCards");
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name receiveCardActivationPasscode
   * @description get passcode to active card
   */

  async receiveCardActivationPasscode({ rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardAdd)) return;
    try {
      const { data, status } = await axios.post("/api/cards/init-activate", body);
      if (status === 200) {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name activateCard
   * @description activate card
   */

  async activateCard({ dispatch, rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardAdd)) return;
    // eslint-disable-next-line no-useless-catch
    try {
      const { status } = await axios.post("/api/cards/complete-activate", body);
      if (status === 200) {
        dispatch("fetchCards");
        return status
      }
    } catch (e) {
      throw e;
    }
  },

  /**
   * @name getCardDetailsInfo
   * @description get information about card
   */

  async getCardDetailsInfo({ rootState }, publicToken) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardViewCredentials)) return;
    try {
      const { data, status } = await axios.get(`/api/cards/info/${publicToken}`);
      if (status === 200) {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name changeCardPhone
   * @description change Cardholder's phone
   */

  async changeCardPhone({ rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/change-phone", body);
      if (status === 200) {
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name changeCardPhone
   * @description change Cardholder's email
   */

   async changeCardEmail({ rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/change-email", body);
      if (status === 200) {
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name changeCardLimits
   * @description change card limit rules
   */

  async changeCardLimits({ rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/limits", body);
      if (status === 200) {
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name freezeCard
   * @description freezeCard card
   */

  async freezeCard({ dispatch, rootState }, token) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/freeze", { token });
      if (status === 200) {
        dispatch("fetchCards");
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name unFreezeCard
   * @description unFreezeCard card
   */

  async unFreezeCard({ dispatch, rootState }, token) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/unfreeze", { token });
      if (status === 200) {
        dispatch("fetchCards");
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name changeCardSecurity
   * @description change card security settings
   */

  async changeCardSecurity({ rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/security", body);
      if (status === 200) {
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name sendPasscode
   * @description send card 3D-Secure code by sms
   */

  async sendPasscode({ rootState }, token) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/send-passcode", { token });
      if (status === 200) {
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name sendPinCode
   * @description send card PinCode by sms
   */

  async sendPinCode({ rootState }, token) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/send-pin", { token });
      if (status === 200) {
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async changeAddress({ dispatch, rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    const res = await axios.post("/api/cards/change-address", body);
    if (res.status === 200) {
      dispatch("fetchCards");
      return res;
    }
  },

  /**
   * @name renewCard
   * @description renewCard
   */

  async renewCard({ dispatch, rootState }, token) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/renew", { token });
      if (status === 200) {
        dispatch("fetchCards");
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name closeCard
   * @description closeCard
   */

  async closeCard({ dispatch, rootState }, token) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardEdit)) return;
    try {
      const { status } = await axios.post("/api/cards/close", { token });
      if (status === 200) {
        dispatch("fetchCards");
        return status;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getTypeOfCards({ commit, dispatch, rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) return;
    try {
      const { status, data } = await axios.get("/api/cards/types");
      if (status === 200 && data.length) {
        state.isLoadingCartTypesArts = true;
        const filteredCardTypes = data.filter((typeArt) => typeArt.availabilityForClient === 'Available');
        commit("SET_CARD_TYPES", filteredCardTypes);
        let ids = Array.from(new Set(filteredCardTypes.map((card) => card?.id)));
        if (state.cardTypesArts.length) {
          const cardTypesArtsIds = state.cardTypesArts.map((typeArt) => typeArt.id);
          ids = ids.filter((num) => !cardTypesArtsIds.includes(num));
        }
        if (ids.length) {
          ids.forEach(async (id, i) => {
            const cardTypeArt = await dispatch("fetchCardTypeArtById", id);
            if (cardTypeArt) {
              cardTypeArt.id = id;
              commit("SET_CARD_TYPES_ART", cardTypeArt);
              if (i === ids.length - 1) {
                state.isLoadingCartTypesArts = false;
              }
            }
          });
        } else {
          state.isLoadingCartTypesArts = false;
        }
        console.log("isLoading");
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getDefaultAddress({ commit, rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardAdd)) return;
    try {
      const { status, data } = await axios.get("/api/cards/get-default-delivery-address");
      if (status === 200 && data) {
        console.log(data, "data");
        commit("SET_DEFAULT_DELIVERY_ADDRESS", data);
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async getShippingClass({ commit, rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) return;
    const { status, data } = await axios.post("/api/cards/get-shipping-info", body);
    if (status === 200) {
      commit("SET_SHIPPING_CLASS", data);
      return { status, data };
    }
  },
  async createCard({ dispatch, rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardAdd)) return;
    const { status, data } = await axios.post("/api/cards/create", body);
    if (status === 200) {
      dispatch("fetchCards");
      return { status, data };
    }
  }
};

const getters = {
  defaultDeliveryAddress: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.CardAdd) ? state.defaultDeliveryAddress : null
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
